// NOTE the generated observation and invers are both present in core and device, use of device in graph is erronous.

const upProperties = ['https://w3id.org/rec#isPartOf']

const downProperties = [
  'https://w3id.org/rec#includes',
  'https://w3id.org/rec#hasPart',
]

export { upProperties, downProperties }
